import MessageItem from "./MessageItem";

export default MessageItem;